import { Box } from '@chakra-ui/react';
import { BellOff } from 'lucide-react';

type Props = {
  /** Absolute placement, for the corner of a department card. */
  position?: 'static' | 'corner';
};

/**
 * Marks a thread whose notifications are silenced.
 *
 * Sits beside the unread marker rather than replacing it: a muted chat still collects
 * unread messages, it just does not announce them, and hiding that would make muting
 * feel like leaving.
 */
export function MutedBell({ position = 'static' }: Props) {
  return (
    <Box
      color="volyx.textSecondary"
      flexShrink={0}
      display="flex"
      aria-label="Notifications muted"
      {...(position === 'corner' ? { position: 'absolute', top: 2, right: 6 } : {})}
    >
      <BellOff size={13} />
    </Box>
  );
}
